type Row = {
  term: string;
  detail: string;
};

type TableProps = {
  caption: string;
  rows: Row[];
};

export function Table({ caption, rows }: TableProps) {
  return (
    <div className="surface-card overflow-hidden">
      <table className="w-full border-collapse text-left">
        <caption className="sr-only">{caption}</caption>
        <thead className="bg-brand-100">
          <tr>
            <th scope="col" className="px-5 py-4 font-bold">
              Item
            </th>
            <th scope="col" className="px-5 py-4 font-bold">
              Detail
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.term} className="border-t border-line">
              <th scope="row" className="px-5 py-4 align-top font-semibold">
                {row.term}
              </th>
              <td className="px-5 py-4 text-ink-soft">{row.detail}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
